// Separate, second Firebase connection — used ONLY for sending contact-form
// inquiries into the centralized Common Super Admin app. Does not touch or
// replace this site's own Supabase (responses table) or its own Firebase
// project (../firebase.js), which keep handling everything else.
import { initializeApp, getApps, getApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

const centralAdminConfig = {
  apiKey: "AIzaSyCw-mFORJSrZ-E6TXAoYpT5XiJ3JAkACaA",
  authDomain: "common-super-admin.firebaseapp.com",
  projectId: "common-super-admin",
  storageBucket: "common-super-admin.firebasestorage.app",
  messagingSenderId: "1038003638681",
  appId: "1:1038003638681:web:8e7f03ecd1766246bb8308",
};

const CENTRAL_APP_NAME = "centralAdmin";

// This website's identifier in the shared websites/{websiteId}/inquiries
// schema — must match the `website_id` custom claim the Agni admin was
// provisioned with.
export const WEBSITE_ID = "agni";

const centralApp = getApps().some(a => a.name === CENTRAL_APP_NAME)
  ? getApp(CENTRAL_APP_NAME)
  : initializeApp(centralAdminConfig, CENTRAL_APP_NAME);

export const centralDb = getFirestore(centralApp);
